import React from 'react';
import Box from '@mui/material/Box';
import Chip from '@mui/material/Chip';
import CheckRoundedIcon from '@mui/icons-material/CheckRounded';
import RemoveRoundedIcon from '@mui/icons-material/RemoveRounded';
import { tokens as c, toneChipSx } from '../../theme';

/**
 * A status as an icon and a word, dark text on the pale tint of its tone
 * (W2 boards: never colour alone).
 *
 *   <StatusChip tone="success" icon={<CheckRoundedIcon />} label="Paid" />
 *   <StatusChip tone="warning" icon={<ScheduleRoundedIcon />} label="Pending" />
 *
 * tone: 'success' | 'error' | 'warning' | 'amber' | 'info' | 'accent' | 'neutral'.
 */
export default function StatusChip({ tone = 'neutral', label, icon, size = 'small', sx }) {
  if (label === null || label === undefined || label === '') return null;
  return (
    <Chip
      size={size}
      icon={icon || undefined}
      label={label}
      sx={{
        ...toneChipSx(tone),
        height: size === 'small' ? 26 : 30,
        maxWidth: '100%',
        fontSize: 13,
        '& .MuiChip-icon': { color: 'inherit', fontSize: 16, ml: '8px' },
        '& .MuiChip-label': { px: 1, whiteSpace: 'nowrap' },
        ...(sx || {}),
      }}
    />
  );
}

/**
 * Yes / No as a small icon and the word (a check in green, a dash in grey),
 * for true/false cells. Words come from the caller so they are translated.
 */
export function YesNo({ value, yes = 'Yes', no = 'No', sx }) {
  const on = !!value;
  const Icon = on ? CheckRoundedIcon : RemoveRoundedIcon;
  return (
    <Box
      component="span"
      sx={{
        display: 'inline-flex',
        alignItems: 'center',
        gap: 0.5,
        fontSize: 14,
        lineHeight: 1.45,
        whiteSpace: 'nowrap',
        color: on ? c.INK : c.INK_2,
        fontWeight: on ? 600 : 400,
        ...(sx || {}),
      }}
    >
      <Icon aria-hidden="true" sx={{ fontSize: 18, color: on ? c.SUCCESS_TEXT : c.TEXT_3 }} />
      {on ? yes : no}
    </Box>
  );
}
